import { P2Manager } from "../../../LTGame/Physics/P2Manager";
import LTRes from "../../../LTGame/Res/LTRes";
import GlobalUnit from "../../common/GlobalUnit";
import LayerDefine from "../../common/LayerDefine";
import ResDefine from "../../common/ResDefine";
export default class AmmoBase {
    constructor(owner, config) {
        this.owner = owner;
        this.config = config;
        this.cacheMove = 0;
        this.CreateModel();
        this.CreateBody();
    }
    CreateModel() {
        this.rootObj = LTRes.Get(ResDefine.FixPath(this.config.ammo_model));
        GlobalUnit.game.level.AddItemToLevel(this.rootObj);
        this.rootObj.transform.position = this.owner.transform.position;
    }
    CreateBody() {
        let body = this.rootObj.getChildByName("body");
        this.body = P2Manager.instance.CreateBody(body, LayerDefine.Ammo, LayerDefine.Enemy, p2.Body.DYNAMIC);
        P2Manager.instance.AddBody(this.body);
        this.body["use"] = this;
    }
    OnMove(dt) {
        let speed = this.config.ammo_move * dt;
        this.rootObj.transform.localPositionZ += speed;
        this.cacheMove += speed;
        if (this.cacheMove >= this.config.atk_distance) {
            console.log(this.cacheMove);
            this.Destroy();
        }
    }
    Destroy() {
        GlobalUnit.game.player.RemoveAmmo(this);
        this.rootObj.destroy();
        P2Manager.instance.RemoveBody(this.body);
    }
    BeginContact() {
    }
    CheckClear() {
    }
    Update(dt) {
        P2Manager.instance.SyncTransToRigXZ(this.rootObj.transform, this.body);
        this.OnMove(dt);
    }
}
